import { LocalizedString } from './localized-string';

export const DEFAULT_UNIT_ID = 1;

export interface Unit {
    id: number;
    translations: LocalizedString;
    order?: number | null;
    key: string;
}
